export default "__VITE_ASSET__BVglhAnx__";